import axios from "axios";
import { BASE_URL } from "../../Config/BaseUrl";
const token = localStorage.getItem("token");

const createAxiosConfig = (url, method, data) => {
  return {
    method,
    url: `${BASE_URL}${url}`,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data,
  };
};

const SchoolListApi = {
 
  getSchoolList: async (data) => {
    const axiosConfig = createAxiosConfig("search_by_school/", "POST", data);
    return await axios(axiosConfig);
  },
};

export default SchoolListApi;
